<script>
    /**
 *
 *
 *
 *
 */

    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule.js";

    /*                */
    const { rawPricing = {}, deal = {}, variationId } = $props();

    const extraParm = $derived({
        ...(rawPricing.fromPrice ? { "is-starting-price": true } : {}),
        ...(deal?.highlightText ? { "deal-highlight": deal.highlightText } : {}),
        ...(deal?.id ? { "deal-id": deal.id } : {}),
    });

    const contentDresonRule = getContext(contentDresonRuleCtxKey);
</script>

<ofc-pricing-item-v1
    class="reco_cinema__price"
    meta-team="ft6bcn"
    retail-price={rawPricing.retailPrice}
    {...extraParm}
    old-price={rawPricing.oldPrice}
    suggested-retail-price={rawPricing.suggestedRetailPrice}
    unit-price={rawPricing.normPrice}
    unit-price-amount={rawPricing.normAmount}
    unit-price-unit={rawPricing.normUnit}
    data-testid="pricing_item"
>
    <ft9-benefit-tag-v1
        slot="benefit-tag"
        class="reco_cinema__benefit-tag reco_cinema__clickable_element"
        id={`benefit_discount_badge_${variationId}`}
        team="ft6-bcn"
        feature="reco"
        variation-id={variationId}
        data-testid="ft9_benefit_badge_{variationId}"
        remove-expired
        load-on-visibility
        current-context-dreson={contentDresonRule ?? "(und.(ja).(~.(v.1)))"}
    >
    </ft9-benefit-tag-v1>
</ofc-pricing-item-v1>

<style lang="scss">
    .reco_cinema__price {
        margin-top: 8px;
    }
</style>
